import { BootLog, type BootLogLine } from './IntroText';

const LINES: BootLogLine[] = [
  { tag: 'OK', tone: 'ok', msg: 'kernel.boot · vmcore v2.4.0' },
  { tag: 'OK', tone: 'ok', msg: 'postgres@16.3 · schemas mounted' },
  { tag: 'OK', tone: 'ok', msg: 'rls.enforce · all tables' },
  { tag: 'OK', tone: 'brand', msg: 'auth.supabase · jwt verified' },
  { tag: '••', tone: 'warn', msg: 'awaiting credentials...' },
];

export function BootSplash({ compact = false }: { compact?: boolean }) {
  return (
    <div
      style={{
        position: 'absolute',
        bottom: compact ? 40 : 90,
        left: '50%',
        transform: 'translateX(-50%)',
        maxWidth: compact ? 320 : 460,
        width: 'calc(100% - 32px)',
        padding: '14px 18px',
        background: 'rgba(10, 15, 18, 0.7)',
        border: '1px solid rgba(102, 224, 255, 0.18)',
        borderRadius: 5,
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        zIndex: 4,
      }}
    >
      <BootLog lines={LINES} startDelay={0} lineDelay={140} />
    </div>
  );
}
